import React from "react";
import "./Transformativedevelopment.css";
import energyillustration from "../../assets/Promoters-illustration.png";

const PreferredEnergy = () => {
  return (
    <section className="preferred-energy-section-development">
      <div className="preferred-energy-content-development">

        {/* Main Heading */}
        <h2
  className="preferred-energy-title-development" style={{ color: "#193597" }}>
          CM Group of Companies, Promoters & Developers
known for delivering Pollachi's finest villas, 
apartments, hospitals, and schools—
is divesting a pristine 600-acre land parcel, 
offering a blank canvas for 
transformative development.
        </h2>

        {/* Image Section */}
        <div className="preferred-energy-illustration-development">
          <img
            src={energyillustration}
            alt="Renewable Energy Diagram"
            className="preferred-energy-image-development"
          />
        </div>
      </div>
    </section>
  );
};

export default PreferredEnergy;
